<!--
  Landingpage „Selbstbedienungsautomat“. Winkel: SB ohne Schwund/Vertrauens-
  kasse – kein doppeltes Kassenbuch, digital nachweisbar. Referenz: Hofbäckerei
  Hömberg (Live + Video).
-->
<section class="lp-hero">
  <div class="content content--wide lp-hero__grid">
    <div class="lp-hero__text reveal">
      <div class="lp-hero__orb" aria-hidden="true">🔐</div>
      <span class="lp-eyebrow" i18n="@@sb.hero.eyebrow">Selbstbedienung · ohne Schwund</span>
      <h1 class="title display" i18n="@@sb.hero.h1">Selbstbedienungsautomat</h1>
      <div class="line"></div>
      <p class="lp-lead" i18n="@@sb.hero.lead">
        Selbstbedienung ohne die alten Probleme: kein Schwund, kein Bargeld in der Vertrauenskasse,
        kein zweites Kassenbuch. Die <span class="tm">marktbox</span> gibt Ware erst nach Zahlung frei –
        jede Transaktion digital nachweisbar.
      </p>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@sb.hero.ctaShop">Modelle &amp; Preise im Shop</a>
        <a class="lp-cta__ghost" href="#vergleich" (click)="scrollTo($event, 'vergleich')" i18n="@@sb.hero.ctaAnchor">Gegenüber der Vertrauenskasse ↓</a>
      </div>
    </div>
    <figure class="lp-hero__media reveal">
      <img src="assets/headers/marktbox-00-1440.webp"
        alt="marktbox Selbstbedienungsautomat mit abschließbaren Fächern" i18n-alt="@@sb.hero.imgAlt"
        width="1440" height="960" fetchpriority="high" />
      <span class="lp-hero__badge" i18n="@@sb.hero.badge">✅ kein Schwund</span>
    </figure>
  </div>
</section>

<!-- ===== Vergleich zur Vertrauenskasse (eigener Kern) ===== -->
<section id="vergleich" class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@sb.cmp.h2">Besser als offenes Regal &amp; Vertrauenskasse</h2>
    <div class="lp-grid">
      <div class="lp-card reveal">
        <span class="lp-card__ico">🛡️</span>
        <h3 i18n="@@sb.card1.h3">Kein Schwund</h3>
        <p i18n="@@sb.card1.p">Ware wird erst nach Zahlung freigegeben – Schwund wie beim offenen Regal entfällt.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">📒</span>
        <h3 i18n="@@sb.card2.h3">Kein doppeltes Kassenbuch</h3>
        <p i18n="@@sb.card2.p">Keine Bargeldkasse, kein Zählen, kein Abgleich – der Verkauf läuft sauber digital.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">🧾</span>
        <h3 i18n="@@sb.card3.h3">Finanzamt-sicher</h3>
        <p i18n="@@sb.card3.p">Jede Zahlung ist digital dokumentiert und nachweisbar – kein Ärger bei der Prüfung.</p>
      </div>
      <div class="lp-card reveal">
        <span class="lp-card__ico">🌦️</span>
        <h3 i18n="@@sb.card4.h3">Wetterfest &amp; abschließbar</h3>
        <p i18n="@@sb.card4.p">Einzeln verriegelte Klappen und robuste Bauweise – drinnen wie draußen einsetzbar.</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== Video: Hömberg (Facade) ===== -->
<section class="lp-section">
  <div class="content content--wide lp-media-grid">
    <div class="lp-video__text reveal">
      <span class="lp-eyebrow" i18n="@@sb.video.eyebrow">Aus der Praxis · Hofbäckerei Hömberg</span>
      <h2 class="lp-h2" i18n="@@sb.video.h2">Selbstbedienung in echt</h2>
      <p class="lp-lead" i18n="@@sb.video.lead">
        Die Hofbäckerei Hömberg verkauft über die marktbox in Selbstbedienung. Im Video zeigt der
        Betreiber, wie der Automat den Verkauf ohne Personal und ohne Bargeld-Handling möglich macht.
      </p>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@sb.video.cta">Automat konfigurieren</a>
      </div>
    </div>
    <div class="lp-video reveal">
      @if (!videoOpen) {
      <button type="button" class="lp-video__facade" [style.background-image]="'url(' + videoThumb + ')'"
        (click)="openVideo()" aria-label="Video abspielen: Hofbäckerei Hömberg" i18n-aria-label="@@sb.video.aria">
        <span class="lp-video__play"></span>
      </button>
      } @else {
      <iframe [src]="videoUrl!" title="marktbox – Zu Gast bei der Hofbäckerei Hömberg" i18n-title="@@sb.video.title"
        allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen loading="lazy"></iframe>
      }
    </div>
  </div>
</section>

<!-- ===== Live-Link: Hömberg ===== -->
<section class="lp-section lp-section--muted">
  <div class="content content--wide lp-live__grid">
    <div class="lp-live__text reveal">
      <span class="lp-eyebrow" i18n="@@sb.live.eyebrow">Live-Link · Echtzeit</span>
      <h2 class="lp-h2" i18n="@@sb.live.h2">Sieh, was gerade in der Box ist</h2>
      <p class="lp-lead" i18n="@@sb.live.lead">
        Jede marktbox hat ihren eigenen Live-Link – hier am Beispiel der Hofbäckerei Hömberg.
        Kundschaft sieht in Echtzeit, was verfügbar ist.
      </p>
      <ul class="lp-live__list">
        <li i18n="@@sb.live.li1">Echtzeit-Verfügbarkeit, rund um die Uhr</li>
        <li i18n="@@sb.live.li2">Teilbar per Link, QR-Code &amp; auf der eigenen Website</li>
        <li i18n="@@sb.live.li3">Ohne App – einfach im Browser</li>
      </ul>
      <div class="lp-cta">
        <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@sb.live.cta">Automat mit Live-Link sichern</a>
      </div>
    </div>
    <div class="lp-phonecol reveal">
      <div class="lp-phone">
        <div class="lp-phone__island" aria-hidden="true"></div>
        <div class="lp-phone__screen">
          <iframe [src]="liveUrl"
            title="marktbox Live-Link – Hofbäckerei Hömberg: Echtzeit-Verfügbarkeit" i18n-title="@@sb.live.iframeTitle"
            loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <div class="lp-phone__hint" aria-hidden="true"><span class="lp-phone__chev"></span> <ng-container i18n="@@lp.phone.scroll">scrollen</ng-container></div>
          <div class="lp-phone__home" aria-hidden="true"></div>
        </div>
        <div class="lp-phone__corners" aria-hidden="true"></div>
      </div>
      <p class="lp-phone__cap"><span class="lp-live__dot"></span> <ng-container i18n="@@sb.live.cap">Live-Beispiel: Hofbäckerei Hömberg</ng-container></p>
    </div>
  </div>
</section>

<!-- ===== Preise ===== -->
<section id="preise" class="lp-section">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@sb.price.h2">Selbstbedienungsautomat kaufen oder mieten</h2>
    <div class="lp-price-grid">
      <div class="lp-price reveal">
        <span class="lp-price__label" i18n="@@sb.price.buyLabel">Kaufen</span>
        <span class="lp-price__value">ab {{ priceBuyFrom | number : '1.0-0' }} €</span>
        <p i18n="@@sb.price.buyText">Einmalige Investition, dauerhaft dein Automat – ideal für den festen Standort.</p>
      </div>
      <div class="lp-price reveal">
        <span class="lp-price__label" i18n="@@sb.price.rentLabel">Mieten</span>
        <span class="lp-price__value">ab {{ priceRentFrom }} € / Monat</span>
        <p i18n="@@sb.price.rentText">Planbare Kosten, niedrige Einstiegshürde – gut zum Starten und Testen.</p>
      </div>
    </div>
    <div class="lp-cta lp-cta--center reveal">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@sb.price.cta">Zum Shop – Selbstbedienungsautomat konfigurieren</a>
    </div>
    <p class="lp-fineprint reveal" i18n="@@sb.price.fine">
      Passt auch für dich? <a [routerLink]="['/', links.blog, blogSlug]">Ratgeber: Einen Selbstbedienungsschrank eröffnen</a>
    </p>
  </div>
</section>

<!-- ===== FAQ ===== -->
<section class="lp-section lp-section--muted">
  <div class="content content--wide">
    <h2 class="lp-h2 reveal" i18n="@@sb.faq.h2">Häufige Fragen zum Selbstbedienungsautomat</h2>
    <div class="lp-faq reveal">
      @for (f of faqs; track f.q) {
      <details class="lp-faq__item">
        <summary>{{ f.q }}</summary>
        <p>{{ f.a }}</p>
      </details>
      }
    </div>
  </div>
</section>

<!-- ===== Abschluss-CTA ===== -->
<section class="lp-section lp-final reveal">
  <div class="content content--wide">
    <h2 class="lp-h2" i18n="@@sb.final.h2">Bereit für saubere Selbstbedienung?</h2>
    <p class="lp-lead" i18n="@@sb.final.lead">Kein Schwund, kein Bargeld, voller Nachweis – finde dein Modell.</p>
    <div class="lp-cta lp-cta--center">
      <a class="btn btn-primary lp-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@sb.final.cta">Jetzt Modelle &amp; Preise ansehen</a>
    </div>
  </div>
</section>
